import { Component,ViewEncapsulation, OnInit } from '@angular/core';
import { ScreenLoadingService } from '@core/services/screen-loading.service';
import { environment } from '../environments/environment';
import {ShowDiasFaltandoPeriodoVendasService} from '@core/services/show-dias-faltando-periodo-vendas.service'

@Component({
  selector: 'app-root',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    public screenLoadingService: ScreenLoadingService,
    private showDiasFaltandoPeriodoVendasService: ShowDiasFaltandoPeriodoVendasService,
  ){}

  title = 'Duloren';

  ngOnInit(){
    console.log(`ambiente de ${environment.production ? 'prod' : 'dev'}`)

    this.showDiasFaltandoPeriodoVendasService.execute()
  }
}
